module.exports = __webpack_public_path__ + "static/media/red-delete.4cec1cc1.svg";